import React, { useEffect, useState } from "react";
import "./InvoiceDetail.css";
import ebillLogo from "./images/logo2.png";
import { FaCloudDownloadAlt, FaPrint } from "react-icons/fa";
import { MdExpandMore } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import riyalSymbol from "./images/riyal_symbol.svg";
import { useTranslation } from "react-i18next";

const InvoiceDetail = () => {
  const { t } = useTranslation("backend");
  const location = useLocation();
  const navigate = useNavigate();
  const { userEmail, invoice_no } = location.state;
  const [ispaid, setIsPaid] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [wallet, setWallet] = useState(null);
  const [iswallet, setIsWallet] = useState(true);
   const [isStripe, setIsStripe] = useState(true);
  const [commission, setCommission] = useState(null);
  const handlePrint = () => {
    window.print();
  };
  const [isPaypal, setIsPaypal] = useState(false);
  // Handle download invoice
  const handleDownloadInvoice = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/download-invoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...invoiceDetails,
          expiry_date: invoiceDetails.expiry_date || "N/A",
        }),
      });
      if (!response.ok) throw new Error("Invoice generation failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Invoice_Ebill_${invoice_no}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download invoice:", error);
      alert("Could not download the invoice. Please try again.");
    }
  };
  useEffect(() => {
    handelInvoiceDetails();
  }, [userEmail]);
  const handelInvoiceDetails = async () => {
    try {
      const response = await fetch(`${BASE_URL}/invoicedetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: userEmail, invoice_no }),
      });
      const result = await response.json();
      if (response.ok) {
        setInvoiceDetails(result.InvoiceDetails || []);
        if (result.InvoiceDetails.status === "paid") {
          setIsPaid(true);
        }
        if (result.InvoiceDetails.status === "unpaid") {
          fetchWallet();
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCommission();
  }, [BASE_URL]);

  const fetchCommission = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/commission`);
      if (!response.ok) {
        throw new Error("Failed to fetch commission data");
      }
      const data = await response.json();
      setCommission(data);
    } catch (error) {
      console.error("Error fetching commission data:", error);
    }
  };

  const fetchWallet = async () => {
    try {
      const response = await fetch(`${BASE_URL}/get/wallet/${userEmail}`);
      const result = await response.json();

      if (response.ok) {
        setWallet(result.wallet);
      } else {
        console.error("Error fetching wallet:", result.error);
      }
    } catch (error) {
      console.error("Failed to fetch wallet:", error);
    }
  };

  const commissions = ((invoiceDetails.amount * commission) / 100).toFixed(2);
  // Ensure commission and selectedPlan.amount are numbers
  const totalWithCommission = (
    Number(commissions) + Number(invoiceDetails.amount)
  ).toFixed(2);
  const handleWallet = () => {
    setIsPaypal(false);
    setIsWallet(true); // Correcting the state update
  };
  const handleStripe = () => {
    setIsPaypal(false);
    setIsWallet(false); // Correcting the state update
  };
  const handleContinueClick = () => {
    const selectedPayment =
  isPaypal === true && iswallet === false
    ? "paypal"
    : iswallet === true && isPaypal === false
    ? "wallet"
    : "stripe";
    navigate("/dashboard/payments", {
      state: { selectedPlan: invoiceDetails, selectedPayment, userEmail },
    });
  };

  return (
    <div className="invoice-detail">
      <div className="invoice-header">
        <div className="logo-section">
          <h4>{t("invoice_owner")}</h4>
          <img src={ebillLogo} alt="eBill Logo" className="logo" />
        </div>
        <div>
          <span className="line"></span>
          <p style={{ fontWeight: "bold" }}>{invoiceDetails.user_name}</p>
          <p>{invoiceDetails.address}</p>
          <p>{invoiceDetails.email}</p>
        </div>
      </div>

      <div className="invoice-status">
        <div className="invoice-container">
          <h2>
            {t("invoice")} #{invoiceDetails.invoice_no}
          </h2>
          <div>
            <div style={{ textAlign: "left" }}>
              <p>support@ebillsaudia.com</p>
              <p
                style={{
                  marginTop: "30px",
                  padding: "10px 0px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {t("creation_date")}{" "}
                {invoiceDetails.start_date
                  ? invoiceDetails.start_date.split(" ")[0]
                  : "N/A"}
              </p>
              <p
                style={{ padding: "10px 0px", borderBottom: "1px solid #ddd" }}
              >
                {t("last_paid")}:{" "}
                {invoiceDetails.last_payment_date
                  ? invoiceDetails.last_payment_date.split(" ")[0]
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="inside-invoice-status">
          {!ispaid ? (
            <div className="status unpaid">{t("unpaid")}</div>
          ) : (
            <>
              <div className="status paid">
                {t("paid")}
                <p style={{ fontWeight: "100", fontSize: "15px" }}>
                  {invoiceDetails.payment_date}
                </p>
              </div>
            </>
          )}

          <div className="action-buttons">
            <button onClick={handlePrint}>
              <FaPrint style={{ marginRight: "5px" }} />
              {t("print")}
            </button>
            <button className="download-button" onClick={handleDownloadInvoice}>
              <FaCloudDownloadAlt style={{ marginRight: "5px" }} />
              {t("downlaod")}
            </button>
          </div>
        </div>
      </div>

      <div className="invoice-table">
        <table>
          <thead style={{ backgroundColor: "#0f4b60", color: "#ddd" }}>
            <tr style={{ pointerEvents: "none" }}>
              <th>{t("description")}</th>
              <th>{t("amount")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {invoiceDetails.plan_name} - {invoiceDetails.domain_name} (
                {invoiceDetails.payment_date?.split(" ")[0] || "N/A"} {t("to")}{" "}
                {invoiceDetails.expiry_date?.split(" ")[0] || "N/A"})
              </td>
              <td>
                <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                {invoiceDetails.amount}
              </td>
            </tr>
            {!ispaid && (
              <>
                {isPaypal ? (
                  <>
                    <tr>
                      <td>
                        {t("paypal_charge_processing")} ({commission}%)
                      </td>
                      <td>
                        <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                        {commissions}
                      </td>
                    </tr>
                    <tr className="subtotal">
                      <td style={{ textAlign: "right" }}>{t("subtotal")}</td>
                      <td>
                        <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                        {totalWithCommission}
                      </td>
                    </tr>
                    <tr className="total">
                      <td style={{ textAlign: "right" }}>
                        {t("amount_payable")}
                      </td>
                      <td>
                        <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                        {totalWithCommission}
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr className="subtotal">
                      <td style={{ textAlign: "right" }}>{t("subtotal")}</td>
                      <td>
                        <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                        {invoiceDetails.amount}
                      </td>
                    </tr>
                    <tr className="total">
                      <td style={{ textAlign: "right" }}>
                        {t("amount_payable")}
                      </td>
                      <td>
                        <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                        {invoiceDetails.amount}
                      </td>
                    </tr>
                  </>
                )}
              </>
            )}

            {ispaid && (
              <>
                <tr className="subtotal">
                  <td style={{ textAlign: "right" }}>{t("subtotal")}</td>
                  <td>
                    <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                    {invoiceDetails.amount}
                  </td>
                </tr>
                <tr className="total">
                  <td style={{ textAlign: "right" }}>{t("amount_payable")}</td>
                  <td>
                    <img src={riyalSymbol} height={"20px"} alt="riyal"></img>{" "}
                    {invoiceDetails.amount}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="payment-section">
        {!ispaid ? (
          <>
            <p className="payment-button">
              <MdExpandMore style={{ marginRight: "5px" }} />
              {t("make_payment")}
            </p>
            <div className="payment-method">
              <p>{t("payment_method")}</p>
              <span className="payment-line"></span>
              <div>
                <label
                  onClick={() => {
                    setIsPaypal(true);
                    setIsWallet(false);
                  }}
                >
                  <input type="radio" name="payment" />
                  <span>
                    {t("paypal")} (+{commission}%)
                  </span>
                </label>
                <label onClick={handleWallet}>
                  <input type="radio" name="payment" defaultChecked />
                  <span style={{ marginRight: "5px" }}> {t("pay_wallet")}</span>
                </label>
                <label onClick={handleStripe}>
                  <input type="radio" name="payment" />
                  <span style={{ marginRight: "5px" }}> {t("pay_stripe")}</span>
                </label>
              </div>
              {iswallet && wallet !== null && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    paddingRight: "100px",
                  }}
                >
                  <p>
                    {t("wallet_balc")}{" "}
                    <img src={riyalSymbol} height={"20px"} alt="riyal"></img> {wallet}
                  </p>
                </div>
              )}

              <span className="payment-line"></span>
            </div>
            <div className="container-continue">
              <button className="continue-button" onClick={handleContinueClick}>
                {t("continue")}
              </button>
            </div>
          </>
        ) : (
          <p className="thanks-greeting">{t("greeting")}</p>
        )}
      </div>
      <div className="save-back-btn-class">
        <button type="button" className="back-btn" onClick={() => navigate(-1)}>
          {t("back")}
        </button>
      </div>
    </div>
  );
};

export default InvoiceDetail;
